import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { provideConfig } from '@spartacus/core';
import { UigSavedCartDetailsModule } from './details/uig-saved-cart-details.module';
import { UigSavedCartListModule } from './uig-saved-cart-list/uig-saved-cart-list.module';
import { uigSavedCartFormLayoutConfig } from './uig-saved-cart-form-dialog/uig-saved-cart-form-layout.config';
import { UigSavedCartFormDialogModule } from './uig-saved-cart-form-dialog/uig-saved-cart-form-dialog.module';

@NgModule({
    imports: [
      RouterModule,
      UigSavedCartDetailsModule,
      UigSavedCartListModule,
      UigSavedCartFormDialogModule
    ],
    providers: [
      provideConfig(uigSavedCartFormLayoutConfig),
    ],
    declarations: [],
  })
  export class UigSavedCartModule {}